import { render, staticRenderFns } from "./cManage.vue?vue&type=template&id=4b099e20&scoped=true&"
import script from "./cManage.vue?vue&type=script&lang=js&"
export * from "./cManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b099e20",
  null
  
)

export default component.exports